import { Shark, Utils, Component } from "shark-mvc";
import $ from "jquery";

import templateContent from "./client-full-recap.html";
import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import { documentListView } from "../documents/documentListView";

class ClientFullRecapComponent extends Component {
	constructor () {
		super("clientFullRecapComponent");

		this.addTemplate("", templateContent);
	}



		
		
	hide () {
		$("#clientFullRecapModal").modal("hide");
	}

	show (clientGuid) {
		clientManager.getFullReport({guid: clientGuid})
		.then(sharkResponse => {
			Shark.set({clientFullReport: sharkResponse.data});
			Shark.render();

			$("#clientFullRecapModal").modal("show");
		});
	}

	showClientFullRecapBtn_clickHandler (event, data) {
		this.show(data.guid);
	}

	clientFullRecapOpenClientFolderBtn_clickHandler () {
		const currVisit = Shark.get("currVisit");

		folderManager.getPathByReferenceGuid(currVisit.clientGuid, "client")
		.then(folderResponse => {
			console.log({folderResponse})
			
			if (folderResponse.data.length > 0) {
				Shark.set({
					requestedFolderBreadCrumb: folderResponse.data
				});
				Shark.openPage(documentListView);
			}
		});
	}

}

const clientFullRecapComponent = new ClientFullRecapComponent();

Shark.registerComponent(clientFullRecapComponent);

export { clientFullRecapComponent };
